import { AppState, AboutPageSedonaAppState } from '../../../initialStateRegistration';

const getAboutPage = (state: AppState) => (state as AboutPageSedonaAppState).template;

export const getAuthors = (state: AppState) => getAboutPage(state).authors;

export const getAbout = (state: AppState) => getAboutPage(state).about;
